import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4a34e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reminder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-warning",
    style: {"color":"#006aff","font-size":"15px","margin-right":"5px"}
  }),
  /*#__PURE__*/_createElementVNode("p", null, "温馨提示：")
], -1))
const _hoisted_3 = { style: {"white-space":"pre-wrap"} }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.reminder.information), 1),
      _createElementVNode("a", {
        href: _ctx.reminderData._href
      }, _toDisplayString(_ctx.reminder.text), 9, _hoisted_4)
    ])
  ]))
}